
export const keys = {
    all: ["report"],
    data: (
        groupID: number,
        configurationID: number | undefined,
        beginDate: Date | undefined,
        endDate: Date | undefined
    ) => [
            ...keys.all,
            "data", {
                groupID,
                configurationID,
                beginDate,
                endDate
            }
        ],
    deferredData: (
        groupID: number,
        fileStoreID: number | undefined
    ) => [
            ...keys.all,
            "deferredData", {
                groupID,
                fileStoreID,
            }
        ],
    adHocData: (
    ) => [
            ...keys.all,
            "adHocData"
        ],
};
